import { render } from "./RightDrawer.vue?vue&type=template&id=279bd559"
import script from "./RightDrawer.vue?vue&type=script&lang=js"
export * from "./RightDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__